/**
 * Identity of the timeline's "current clip / first scene" for playhead init.
 * Times are intentionally omitted: trimming an interval must not look like a
 * scene change and re-seek the preview to the first interval's start.
 */
export function resolvePlayheadInitKey(
  intervals: Array<{ id: number }>,
  selectedClip?: { id: number } | null,
): string | number | null {
  if (selectedClip) return selectedClip.id;
  if (intervals.length > 0) return intervals[0].id;
  return selectedClip?.id ?? null;
}
